module.exports = __webpack_public_path__ + "fonts/Inter-ThinItalic.a76db06.woff";